import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import storeFactory from './store';
import VueGtag from 'vue-gtag';
import { PautaClient } from './gateways/pautaClient';
import { AdminClient } from './gateways/adminClient';

import VuePlyr from 'vue-plyr';
import '@mdi/font/css/materialdesignicons.css';

// The second argument is optional and sets the default config values for every player.
Vue.use(VuePlyr, {
  plyr: {
    fullscreen: { enabled: true },
    settings: [],
  },
  emit: ['ended'],
});

const {
  VUE_APP_BFF_URL,
  VUE_APP_ANALYTICS,
  VUE_APP_REFRESH_TIME,
} = process.env;

Vue.use(
  VueGtag,
  {
    config: {
      id: VUE_APP_ANALYTICS,
    },
  },
  router,
);

Vue.config.productionTip = false;

const pautaClient = new PautaClient(VUE_APP_BFF_URL);
const adminClient = new AdminClient(VUE_APP_BFF_URL);

const plug = store => {
  store.subscribeAction({
    before: (action, state) => {
      state.pautaClient = pautaClient;
      state.adminClient = adminClient;
      state.REFRESH_TIME = VUE_APP_REFRESH_TIME;
    },
  });
};

const store = storeFactory([plug]);

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
}).$mount('#app');
